export default {
  name: 'AddMultipleMenuItems',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    close() {
      this.file = null;
      this.$emit('close');
    },
    csvToArray(str, delimiter = ',') {
      const rows = str.split(/\r\n|\n\r|\n|\r/);
      const header = rows[0];
      rows.shift(header);
      return rows?.map((row) => row.split(delimiter)) || [];
    },
    onAdd() {
      const reader = new FileReader();
      reader.onload = (event) => {
        const text = event.target.result;
        const datum = this.csvToArray(text) || [];
        this.$emit('add', datum.map(([name, note, price]) => ({
          name,
          note,
          price: +price,
        })));
        this.close();
      };
      reader.readAsText(this.file);
    },
  },
};
